<template>
    <div
        ref="container"
        class="hts-order-time-optimization__container">
        <template v-if="showForm">
            <h3 class="text-indigo-500 mb-2">
                Chi tiết lộ trình tối ưu
            </h3>
            <div class="flex">
                <div class="w-[200px] min-w-[200px] max-w-[200px] overflow-hidden relative z-0 border-b border-r">
                    <div class="h-10 w-full text-warning-500 border box-border pl-1 leading-10">
                        Tháng {{ getMonths[0] }}
                    </div>
                    <template v-if="showForm">
                        <div
                            v-for="(position, index) in positions"
                            :key="index"
                            class="h-32 w-full border-l"
                            :class="{
                                'h-52': index === positions?.length - 1
                            }">
                            <div class="ml-1 flex flex-nowrap h-12 gap-2 items-center">
                                <span class="font-bold">
                                    {{ position?.nodeLocationName }}
                                </span>
                            </div>
                            <div class="h-8 mt-4 relative flex items-center justify-center">
                                <div class="absolute w-1/2 border-b border-dashed top-4 left-[50%]" />
                                <span class="text-center bg-white z-10">
                                    IN
                                </span>
                            </div>
                            <div
                                v-if="index === positions.length - 1"
                                class="h-8 mt-8 relative flex items-center justify-center">
                                <div class="absolute w-1/2 border-b border-dashed top-4 left-[50%]" />
                                <span class="text-center bg-white z-10">
                                    OUT
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="max-w-full overflow-x-auto w-full overflow-y-hidden border-b">
                    <div class="w-full h-10">
                        <div
                            class="relative flex h-full z-10 overflow-hidden"
                            :style="{
                                'min-width': `${dayWidth * getDays.length}px`,
                                width: `${dayWidth * getDays.length}px`,
                                'max-width': `${dayWidth * getDays.length}px`
                            }">
                            <div
                                v-for="(day, index) in getDays"
                                :key="index"
                                class="border-solid border-x"
                                :style="{
                                    'min-width': `${dayWidth}px`,
                                    width: `${dayWidth}px`
                                }">
                                <div class="h-10 border-solid border-y text-center leading-8">
                                    {{ day }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-for="(position, index) in positions"
                        :key="index"
                        class="w-full h-32"
                        :class="{
                            'h-52': index === positions?.length - 1
                        }">
                        <div
                            class="relative flex h-full z-10 overflow-hidden"
                            :style="{
                                'min-width': `${dayWidth * getDays.length}px`,
                                width: `${dayWidth * getDays.length}px`,
                                'max-width': `${dayWidth * getDays.length}px`
                            }">
                            <div
                                v-for="(day, indexDay) in getDays"
                                :key="indexDay"
                                class="border-solid border-x"
                                :style="{
                                    'min-width': `${dayWidth}px`,
                                    width: `${dayWidth}px`
                                }">
                                <div class="h-40">
                                    <div class="mt-16 h-8 w-full flex items-center">
                                        <div
                                            class="border-dashed border-t w-full"
                                            :style="{ transform: `translateY(50%)` }" />
                                    </div>
                                    <div
                                        v-if="index === positions.length - 1"
                                        class="mt-8 h-8 w-full flex items-center">
                                        <div
                                            class="border-dashed border-t w-full"
                                            :style="{ transform: `translateY(50%)` }" />
                                    </div>
                                </div>
                            </div>

                            <div
                                class="absolute h-40 text-center leading-8 z-50"
                                :style="getStylePosition(index)">
                                <!-- tối  ưu -->

                                <div class="mt-16 h-8 flex items-center w-full relative">
                                    <div />

                                    <div
                                        class="absolute line w-full"
                                        :style="getStyleLine(index, 'in', true)"/>

                                    <div
                                        placement="top"
                                        class="absolute dot permanent "
                                        :style="getStyleDot(index, 'in', 'earliest', true)">
                                        <div
                                            v-if="getTimeInNode(index, 'in', 'earliest')"
                                            class="relative ">
                                            <div class="translate-left">
                                                <!--
                                                  <h5 class="leading-[1] w-full bg-white inline">
                                                  In {{ position?.nodeLocationName }}
                                                  </h5>
                                                  <br class="h-0">
                                                -->
                                                <p class="leading-[1] w-full bg-white inline">
                                                    {{ getTimeInNode(index, 'in', 'earliest') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        placement="top"
                                        class="absolute dot permanent"
                                        :style="getStyleDot(index, 'in', 'latest', true)">
                                        <div
                                            v-if="getTimeInNode(index, 'in', 'latest')"
                                            class="relative ">
                                            <div class="translate-right">
                                                <!--
                                                  <h5 class="leading-[1] w-full bg-white inline">
                                                  In {{ position?.nodeLocationName }}
                                                  </h5>
                                                  <br class="h-0">
                                                -->
                                                <p class="leading-[1] w-full bg-white inline">
                                                    {{ getTimeInNode(index, 'in', 'latest') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    v-if="index === positions.length - 1"
                                    class="mt-8 h-8 flex items-center w-full relative">
                                    <div
                                        class="absolute line w-full"
                                        :style="getStyleLine(index, 'out', true)"/>

                                    <div
                                        placement="top"
                                        class="absolute dot permanent "
                                        :style="getStyleDot(index, 'out', 'earliest', true)">
                                        <div
                                            v-if="getTimeInNode(index, 'out', 'earliest')"
                                            class="relative ">
                                            <div class="translate-left">
                                                <!--
                                                  <h5 class="leading-[1] w-full bg-white inline">
                                                  Out {{ position?.nodeLocationName }}
                                                  </h5>
                                                  <br class="h-0">
                                                -->
                                                <p class="leading-[1] w-full bg-white inline">
                                                    {{ getTimeInNode(index, 'out', 'earliest') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        placement="top"
                                        class="absolute dot permanent"
                                        :style="getStyleDot(index, 'out', 'latest', true)">
                                        <div
                                            v-if="getTimeInNode(index, 'out', 'latest')"
                                            class="relative ">
                                            <div class="translate-right">
                                                <!--
                                                  <h5 class="leading-[1] w-full bg-white inline">
                                                  Out {{ position?.nodeLocationName }}
                                                  </h5>
                                                  <br class="h-0">
                                                -->
                                                <p class="leading-[1] w-full bg-white inline">
                                                    {{ getTimeInNode(index, 'out', 'latest') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script setup lang="ts">
import cloneDeep from 'lodash-es/cloneDeep'
const { $dayjs, $formatters, $disableReactive } = useNuxtApp()
const dayWidth = ref(144) // độ dài của điểm (px)
const container = ref()

const showForm = ref(false)
const positions = ref([] as any[])
const waitingTimes = ref([] as any[])
const optimizeWaitingTimes = ref([] as any[])
const inDay = ref('')
const outDay = ref('')
const earliest = ref<{ [key: string]: any }>({})
const latest = ref<{ [key: string]: any }>({})
const permanent = ref<{ [key: string]: any }>({})
const earliestOptimize = ref<{ [key: string]: any }>({})
const latestOptimize = ref<{ [key: string]: any }>({})
const minWaitingTimeWarning = ref<{ [key: string]: any }>({})
const minWaitingTimeWarningOptimal = ref<{ [key: string]: any }>({})
const manualPlanning = ref<{ [key: string]: any }>({})
const solution = ref('')

const positionLength = computed(() => {
  return positions.value.length || 0
})

const show = (positionsData: any[], waitingTimesProp: Array<any>, optimizeWaitingTimeProp: Array<any>, data?: { [key: string]: any }) => {
  if (!Array.isArray(positionsData)) {
    return
  }
  positions.value = cloneDeep(positionsData)
  waitingTimes.value = cloneDeep(waitingTimesProp)
  optimizeWaitingTimes.value = cloneDeep(optimizeWaitingTimeProp)
  const { minWaitingTimeWarningData, minWaitingTimeWarningOptimalData } = data || {}
  // lưu thời gian tổng hợp
  earliest.value = waitingTimesProp?.filter((item: any) => item?.type === 'earliest')?.[0] || {}
  permanent.value = waitingTimesProp?.filter((item: any) => item?.type === 'permanent')?.[0] || {}
  latest.value = waitingTimesProp?.filter((item: any) => item?.type === 'latest')?.[0] || {}

  // lưu thời gian tối ưu
  earliestOptimize.value = optimizeWaitingTimeProp?.filter((item: any) => item?.type === 'earliest')?.[0] || {}
  latestOptimize.value = optimizeWaitingTimeProp?.filter((item: any) => item?.type === 'latest')?.[0] || {}

  // tăng giảm 1 ngày để khung rộng ra, không bị che node
  const timeInFisrtNode = $dayjs(getInRoute()).subtract(1, 'day')
  const timeOutLastNode = $dayjs(getOutRoute()).add(1, 'day')

  inDay.value = $formatters.datetime(timeInFisrtNode, 'YYYY-MM-DD HH:mm')
  outDay.value = $formatters.datetime(timeOutLastNode, 'YYYY-MM-DD HH:mm')
  const containerWidth = container.value.clientWidth - 200
  if (containerWidth / getDays.value.length < 144 || !getDays.value.length) {
    dayWidth.value = 144
  } else {
    dayWidth.value = Math.floor(containerWidth / getDays.value.length)
  }

  minWaitingTimeWarning.value = cloneDeep(minWaitingTimeWarningData) || {}
  minWaitingTimeWarningOptimal.value = cloneDeep(minWaitingTimeWarningOptimalData) || {}
  showForm.value = true
}

// in điểm
const inNodeTime = (index: number, optimize?: boolean) => {
  if (optimize) {
    return (
      earliestOptimize.value.data?.[index]?.IN?.timeInPosition ||
      earliestOptimize.value.data?.[index]?.IN?.time ||
      latestOptimize.value.data?.[index]?.IN?.timeInPosition ||
      latestOptimize.value.data?.[index]?.IN?.time
    )
  }
  return (
    earliest.value.data?.[index]?.IN?.timeInPosition ||
    earliest.value.data?.[index]?.IN?.time ||
    permanent.value.data?.[index]?.IN?.[0]?.timeInPosition ||
    latest.value.data?.[index]?.IN?.timeInPosition ||
    latest.value.data?.[index]?.IN?.time
  )
}

// out điểm
const outNodeTime = (index: number, optimize?: boolean) => {
  if (optimize) {
    return (
      latestOptimize.value.data?.[index]?.OUT?.timeOutPosition ||
      latestOptimize.value.data?.[index]?.OUT?.time ||
      earliestOptimize.value.data?.[index]?.OUT?.timeOutPosition ||
      earliestOptimize.value.data?.[index]?.OUT?.time
    )
  }
  return (
    latest.value.data?.[index]?.OUT?.timeOutPosition ||
    latest.value.data?.[index]?.OUT?.time ||
    earliest.value.data?.[index]?.OUT?.timeOutPosition ||
    earliest.value.data?.[index]?.OUT?.time
  )
}

const getInRoute = () => {
  const dayList = [] as string[]
  for (let i = 0; i < positionLength.value - 1; i++) {
    dayList.push(inNodeTime(i))
  }

  const min = $lodash.min(dayList)
  return min
}

const getOutRoute = () => {
  const dayList = [] as string[]
  for (let i = 0; i <= positionLength.value - 1; i++) {
    dayList.push(outNodeTime(i))
  }
  return $lodash.max(dayList)
}

// cố định của điểm
const inNodeTimePermanent = (index: number) => {
  return permanent.value.data?.[index]?.IN?.[0]?.timeInPosition
}

// in sn mn
const inEarliestLatest = (index: number, optimize?: boolean) => {
  if (optimize) {
    return {
      inEarliest: earliestOptimize.value.data?.[index]?.IN?.timeInPosition || earliestOptimize.value.data?.[index]?.IN?.time,
      inLatest: latestOptimize.value.data?.[index]?.IN?.timeInPosition || latestOptimize.value.data?.[index]?.IN?.time
    }
  }

  return {
    inEarliest: earliest.value.data?.[index]?.IN?.timeInPosition || earliest.value.data?.[index]?.IN?.time,
    inLatest: latest.value.data?.[index]?.IN?.timeInPosition || latest.value.data?.[index]?.IN?.time
  }
}
// out sn mn
const outEarliestLatest = (index: number, optimize?: boolean) => {
  if (optimize) {
    return {
      outEarliest: earliestOptimize.value.data?.[index]?.OUT?.timeOutPosition || earliestOptimize.value.data?.[index]?.OUT?.time,
      outLatest: latestOptimize.value.data?.[index]?.OUT?.timeOutPosition || latestOptimize.value.data?.[index]?.OUT?.time
    }
  }

  return {
    outEarliest: earliest.value.data?.[index]?.OUT?.timeOutPosition || earliest.value.data?.[index]?.OUT?.time,
    outLatest: latest.value.data?.[index]?.OUT?.timeOutPosition || latest.value.data?.[index]?.OUT?.time
  }
}

// trả về danh sách những ngày làm việc
const getDays = computed(() => {
  let currentDay = $dayjs(inDay.value)
  const currentOutDay = $dayjs(outDay.value)
  const daysList: string[] = []

  while (currentDay.isBefore(currentOutDay) || currentDay.isSame(currentOutDay, 'day')) {
    daysList.push(currentDay.format('DD'))
    currentDay = currentDay.add(1, 'day')
  }

  return daysList
})

// các thánh làm việc
const getMonths = computed(() => {
  let currentDay = $dayjs(inDay.value)
  const currentOutDay = $dayjs(outDay.value)

  const monthsList: string[] = []

  while (currentDay.isBefore(currentOutDay) || currentDay.isSame(currentOutDay, 'month')) {
    monthsList.push(currentDay.format('MM/YYYY'))
    currentDay = currentDay.add(1, 'month')
  }

  return monthsList
})

// số phút của tất cả các này làm việc
const getMinutes = computed(() => {
  if (getDays.value.length) {
    return getDays.value.length * 24 * 60
  }

  return 0
})

// mốc thời gian in out của điểm
const diffTime = (timeA: string | Dayjs, timeB: string | Dayjs, startOfDayA?: boolean) => {
  if (!timeA || !timeB) {
    return null
  }
  let date1 = typeof timeA === 'string' ? $dayjs(timeA) : timeA
  const date2 = typeof timeB === 'string' ? $dayjs(timeB) : timeB

  if (startOfDayA) {
    date1 = date1.startOf('date')
  }

  return Math.abs(date1.diff(date2, 'minute'))
}

const getStylePosition = (index: number) => {
  const timeInNode = inNodeTime(index)
  const timeOutNode = outNodeTime(index)
  const timeStampInNode = diffTime(inDay.value, timeInNode, true) || 0
  const timeStampOutNode = diffTime(inDay.value, timeOutNode, true) || 0

  const left = Math.floor((timeStampInNode / getMinutes.value) * getDays.value.length * dayWidth.value) // px
  const right = Math.floor((timeStampOutNode / getMinutes.value) * getDays.value.length * dayWidth.value) // px
  return `left: ${left}px; width: ${right - left}px; max-width: ${right - left}px`
}

const getStyleLine = (index: number, type: string, optimize?: boolean) => {
  // if (index !== 1) {
  //   return 'display: none;'
  // }

  const timeInNode = inNodeTime(index)
  const timeOutNode = outNodeTime(index)

  const diffInOutNode = diffTime(timeInNode, timeOutNode)

  if (type === 'in') {
    const { inEarliest, inLatest } = inEarliestLatest(index, optimize)
    if (!inEarliest || !inLatest || inEarliest === inLatest) {
      return 'display: none;'
    }

    const diffTimeTmp = diffTime(inEarliest, inLatest)
    const diffTimeTmp2 = diffTime(timeInNode, inEarliest) || 0
    if (!diffTimeTmp || !diffInOutNode) {
      return ''
    }

    const width = (diffTimeTmp / diffInOutNode) * 100
    const left = (diffTimeTmp2 / diffInOutNode) * 100
    return `width: ${width}%; left: ${left}%`
  }

  if (type === 'out') {
    const { outEarliest, outLatest } = outEarliestLatest(index, optimize)
    if (!outEarliest || !outLatest || outEarliest === outLatest) {
      return 'display: none;'
    }

    const diffTimeTmp = diffTime(outEarliest, outLatest)
    const diffTimeTmp2 = diffTime(timeInNode, outEarliest) || 0
    if (!diffTimeTmp || !diffInOutNode) {
      return ''
    }

    const width = (diffTimeTmp / diffInOutNode) * 100
    const left = (diffTimeTmp2 / diffInOutNode) * 100
    return `width: ${width}%; left: ${left}%`
  }

  return 'display: none;'
}

const getStyleDot = (index: number, type: string, typeTime: string, optimize?: boolean) => {
  const timeInNode = inNodeTime(index)
  const timeOutNode = outNodeTime(index)

  const diffInOutNode = diffTime(timeInNode, timeOutNode)
  const inPermanent = inNodeTimePermanent(index)

  if (type === 'in' && diffInOutNode) {
    const { inEarliest, inLatest } = inEarliestLatest(index, optimize)

    if (inEarliest && typeTime === 'earliest') {
      const diffTimeTmp = diffTime(timeInNode, inEarliest) || 0
      const left = (diffTimeTmp / diffInOutNode) * 100
      return `left: ${left}%`
    }

    if (inLatest && typeTime === 'latest') {
      const diffTimeTmp = diffTime(timeInNode, inLatest) || 0
      const left = (diffTimeTmp / diffInOutNode) * 100
      return `left: ${left}%`
    }

    if (inPermanent && typeTime === 'permanent') {
      const diffTimeTmp = diffTime(timeInNode, inPermanent) || 0
      const left = (diffTimeTmp / diffInOutNode) * 100
      return `left: ${left}%`
    }
  }

  if (type === 'out' && diffInOutNode) {
    const { outEarliest, outLatest } = outEarliestLatest(index, optimize)

    if (outEarliest && typeTime === 'earliest') {
      const diffTimeTmp = diffTime(timeInNode, outEarliest) || 0
      const left = (diffTimeTmp / diffInOutNode) * 100
      return `left: ${left}%`
    }

    if (outLatest && typeTime === 'latest') {
      const diffTimeTmp = diffTime(timeInNode, outLatest) || 0
      const left = (diffTimeTmp / diffInOutNode) * 100
      return `left: ${left}%`
    }
  }

  return 'display: none;'
}

const getTimeInNode = (index: number, type: string, timeTime = 'earliest') => {
  const timeFormat = 'DD/MM/YYYY HH:mm'
  if (type === 'in') {
    let { inEarliest, inLatest } = inEarliestLatest(index, true)

    inEarliest = inEarliest ? $formatters.datetime(inEarliest, timeFormat) : null
    inLatest = inLatest ? $formatters.datetime(inLatest, timeFormat) : null

    // if (inEarliest && inLatest && inEarliest !== inLatest) {
    //   return `${inEarliest} - ${inLatest}`
    // }

    if (timeTime === 'earliest') {
      return inEarliest || inLatest || ''
    }

    if (inLatest === inEarliest) {
      return ''
    }

    return inLatest || inEarliest || ''
  }

  if (type === 'out') {
    let { outEarliest, outLatest } = outEarliestLatest(index, true)

    outEarliest = outEarliest ? $formatters.datetime(outEarliest, timeFormat) : null
    outLatest = outLatest ? $formatters.datetime(outLatest, timeFormat) : null

    // if (outEarliest && outLatest && outEarliest !== outLatest) {
    //   return `${outEarliest} - ${outLatest}`
    // }

    if (timeTime === 'earliest') {
      return outEarliest || outLatest || ''
    }

    if (outLatest === outEarliest) {
      return ''
    }

    return outLatest || outEarliest || ''
  }

  return ''
}

const resetFields = () => {
  positions.value = []
  waitingTimes.value = []
  optimizeWaitingTimes.value = []
  solution.value = ''
  manualPlanning.value = {}
}

const close = () => {
  resetFields()
  showForm.value = false
}

defineExpose({ show, close })
</script>
